/** How long a pricing option runs. Used by the admin panel to work out an end date. */
export interface CoachingTermLength {
  value: number
  unit: 'day' | 'week' | 'month'
}

export interface CoachingPriceOption {
  label: string
  price: string
  detail?: string
  length?: CoachingTermLength
}

export const coachingPricing: Record<string, CoachingPriceOption[]> = {
  strongAgain: [
    {
      label: 'Founding Client — 3-Month Commitment',
      price: '$347/month',
      detail: '$1,041 minimum investment',
      length: { value: 3, unit: 'month' },
    },
  ],

  nutritionBlueprint: [
    {
      label: 'Founding Client — 12 Weeks',
      price: '$349',
      detail: '12 weeks',
      length: { value: 12, unit: 'week' },
    },
  ],

  championsBlueprint: [
    {
      label: '12 Weeks',
      price: '$900',
      length: { value: 12, unit: 'week' },
    },
    {
      label: '14 Weeks',
      price: '$1,050',
      length: { value: 14, unit: 'week' },
    },
    {
      label: '16 Weeks',
      price: '$1,200',
      length: { value: 16, unit: 'week' },
    },
  ],

  proLook: [
    {
      label: '12 Weeks',
      price: '$799',
      length: { value: 12, unit: 'week' },
    },
    {
      label: '14 Weeks',
      price: '$925',
      length: { value: 14, unit: 'week' },
    },
    {
      label: '16 Weeks',
      price: '$1,050',
      length: { value: 16, unit: 'week' },
    },
  ],
  eliteCompetitiveEdge: [
    {
      label: '12 Weeks',
      price: '$749',
      length: { value: 12, unit: 'week' },
    },
    {
      label: '16 Weeks',
      price: '$949',
      length: { value: 16, unit: 'week' },
    },
    {
      label: '24 Weeks',
      price: '$1,399',
      length: { value: 24, unit: 'week' },
    },
  ],
}
